import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Loading } from "../../components/shared";
import { CreditCard } from "lucide-react";

export default function VendorSubscription() {
  const [subscription, setSubscription] = useState(null);
  useEffect(() => {
    api.get("/vendor/subscription").then((response) => setSubscription(response.data));
  }, []);
  if (!subscription) return <Loading />;

  const isWaived = subscription.effective_status === "waived";
  return (
    <section className="max-w-3xl" data-testid="vendor-subscription-page">
      <div className="border-b border-slate-200 pb-5">
        <p className="text-xs font-semibold uppercase tracking-wide text-emerald-700">Commercial information</p>
        <h1 className="mt-2 font-display text-3xl font-bold">Subscription</h1>
        <p className="mt-2 text-sm text-slate-600">Billing and receipts remain managed by MySocietyMitra Company Finance.</p>
      </div>
      <div className="mt-6 border border-slate-200 bg-white p-6 sm:p-8">
        <div className="flex items-start justify-between gap-4">
          <CreditCard className="h-7 w-7 text-emerald-700" />
          <span className="border border-slate-200 px-3 py-1 text-xs font-bold uppercase" data-testid="vendor-subscription-effective-status">
            {subscription.effective_status}
          </span>
        </div>
        <dl className="mt-7 grid gap-5 sm:grid-cols-2">
          <Item label="Plan" testId="vendor-subscription-plan" value={subscription.plan || "Monthly"} />
          <Item label="Billing cycle" testId="vendor-subscription-cycle" value="Monthly" />
          <Item label="Standard price" testId="vendor-subscription-price" value={`₹${subscription.monthly_amount || 0} / month`} />
          <Item label="Renewal date" testId="vendor-subscription-renewal" value={(subscription.next_renewal || subscription.trial_ends || "").slice(0, 10) || "Not scheduled"} />
          {isWaived && <Item label="Waiver" testId="vendor-subscription-waiver" value="Waived — no payment recorded" />}
          {subscription.invoice && <Item label="Invoice reference" testId="vendor-subscription-invoice" value={subscription.invoice.number || subscription.invoice.invoice_id} />}
        </dl>
        {isWaived ? (
          <p className="mt-7 border-l-4 border-sky-600 bg-sky-50 px-4 py-3 text-sm text-sky-950" data-testid="vendor-subscription-waived-note">
            This subscription is waived. No payment or Company revenue is shown for the waived period.
          </p>
        ) : subscription.effective_status === "expired" ? (
          <p className="mt-7 border-l-4 border-amber-600 bg-amber-50 px-4 py-3 text-sm text-amber-950" data-testid="vendor-subscription-expired-note">
            Renewal is pending. Contact MySocietyMitra for your current commercial status.
          </p>
        ) : null}
      </div>
    </section>
  );
}

function Item({ label, value, testId }) {
  return (
    <div data-testid={testId}>
      <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</dt>
      <dd className="mt-1 text-sm font-semibold text-slate-950">{value}</dd>
    </div>
  );
}